import { Button, Flex, Row, Col, Spin, Empty } from "antd"
import SkeletonImage from "antd/es/skeleton/Image";
import { Link } from "react-router-dom";
import '../styles/display_element.css'

function DisplayElements({items, images, imagesLoaded, language}) {
    return (
        <Flex flex="column" align="center" className="flex-content">
            {imagesLoaded ? 
            <Row gutter={[16, 16]} className="grid">
                {items.length > 0 ? (
                    items.map((item, index) => {
                        const key = `col-${index}`;
                        return (
                            <Col className="column" key={index} >
                                <Link to={item.url ? "/" + item.url : "/" + item.link}>
                                    <div className="img-container">
                                        {imagesLoaded
                                            ? (images.hasOwnProperty(item.id) && images[item.id] !== null ? <img alt={item.title} src={images[item.id]}></img> : <SkeletonImage className="image"/>)
                                            : <Spin size="large" className="loading-gif"></Spin>
                                        }
                                        <div className="img-content">
                                            <h2>{item.perex ? item.perex : item.title}</h2>
                                            <Button style={{fontSize: "30px", padding: "20px", marginTop:"50px"}} color="red" variant='solid'>
                                                {language === 'sk' ? "Viac" : "More"}
                                            </Button>
                                        </div>
                                    </div>
                                </Link>
                            </Col>
                        );
                    })
                ) : (
                    <Empty description="No posts found."></Empty>
                )}
            </Row>
            : <Spin size="large" style={{padding: "300px"}}></Spin>
            }
        </Flex>
    )
}

export default DisplayElements;
